export const LOADERS_FEATURE_KEY = 'loaders';
